module.exports = __webpack_public_path__ + "static/media/BTC.eb9d07df.jpg";